export default __webpack_public_path__ + "static/media/image-10.5d708127.png";